import { render, staticRenderFns } from "./CurrentListings.vue?vue&type=template&id=4866731c"
import script from "./CurrentListings.vue?vue&type=script&lang=js"
export * from "./CurrentListings.vue?vue&type=script&lang=js"
import style0 from "./CurrentListings.vue?vue&type=style&index=0&id=4866731c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports